import React from 'react';
import { MFOutlet, XvAppId } from '@im/ui-lib/mf-utils';
import { ProviderComposer } from './AppProviderComposer';
import { getAppProviders } from './app-provider-config';

type AppProvidersProps = {
  appId: XvAppId;
  basename?: string;
  children: React.ReactNode;
  envVars: any;
  mfOutlets?: MFOutlet[];
};

export function AppProvidersV2({
  appId,
  children,
  ...others
}: AppProvidersProps) {
  const appProviders = getAppProviders(appId, others);

  return (
    <ProviderComposer providers={appProviders}>{children}</ProviderComposer>
  );
}
